import { Chain } from "./Chain";
import { esdtControlChanges, esdtFreeze, esdtIssueToken, esdtLocalBurn, esdtLocalMint, esdtPause, esdtSetRole, esdtTrasferToken, esdtUnFreeze, esdtUnPause, esdtUnSetRole, esdtWipe, getCollectionInfo, getTokenInfo, metaEsdtChangeNftToMetaEsdt, metaEsdtRegisterMetaEsdt, multiversxGetTxStatus, nftAddUri, nftCreate, nftFreezeSingleNft, nftIssue, nftSetSpecialRole, nftStopNftCreate, nftTransfer, nftTransferNftCreateRole, nftUnFreezeSingleNft, nftUpdateAttributes, nftWipeSingleNft, sftEsdtNftAddQuantity, sftEsdtNftBurn, sftEsdtNftCreate, sftIssue, sftSetSpecialRole } from "./axiosRequests/axiosHandler";
import {
    GetCollectionInfo,
    EsdtControlChanges,
    EsdtFreeze,
    EsdtPause,
    EsdtUnFreeze,
    EsdtUnPause,
    EsdtWipe,
    MultiversGetTxStatus,
    EsdtIssue,
    EsdtLocalBurn,
    EsdtLocalMint,
    EsdtSetRole,
    EsdtTransfer,
    MetaEsdtChangeNftToMetaEsdt,
    MetaEsdtRegisterMetaEsdt,
    NftAddUri,
    NftCreate,
    NftFreezeSingleNft,
    NftIssue,
    NftSetSpecialRole,
    NftStopNftCreate,
    NftTransfer,
    NftTransferNftCreateRole,
    NftUnFreezeSingleNft,
    NftUpdateAttributes,
    NftWipeSingleNft,
    SftEsdtNftAddQuantity,
    SftEsdtNftBurn,
    SftEsdtNftCreate,
    SftSetSpecialRole,
    SftIssue,
    GetTokenInfo
 } from "./models";

export class MultiversX extends Chain { 
    // TODO: verify here if eerything works as expected with sign and send process
    // public establishConnection = async (networkProvider: any): Promise<ApiNetworkProvider> => {
    //     return new ApiNetworkProvider(networkProvider)
    // }

    // public signTransaction = async (
    //     transaction: any,
    //     password?: any,
    //     jsonWallet?: any,
    //     pemFilePath?: any
    // ): Promise<any> => {
    //     try {
    //         let signer
    //         // Case UserSigner form Wallet
    //         if (password && jsonWallet) {
    //             signer = UserSigner.fromWallet(jsonWallet, password!)
    //             await signer.sign(transaction)
    //         }
    
    //         // Case UserSigner from PEM file
    //         if (pemFilePath) {
    //             const pemText = fs.readFileSync(pemFilePath, 'utf8')
    //             signer = UserSigner.fromPem(pemText)
    //             await signer.sign(transaction)
    //         }
    //         return transaction
    //     } catch (err) {
    //         if (!password && !jsonWallet && !pemFilePath) {
    //             throw new Error('You have not provided the pem file path or password and wallet')
    //         }
    //     }   
    // }

    // public sendTransaction = async (
    //     transaction: Transaction,
    //     connection: ApiNetworkProvider
    // ) => {
    //     await connection.sendTransaction(transaction)
    // }

    public esdtIssueToken = async (
        payload: EsdtIssue
    ): Promise<any> => {
        return await esdtIssueToken(payload, this.initialize);
    }

    public esdtTransferToken = async (
        payload: EsdtTransfer
    ): Promise<any> => {
        return await esdtTrasferToken(payload, this.initialize);
    }

    public esdtSetRole = async (
        payload: EsdtSetRole
    ): Promise<any> => {
        return await esdtSetRole(payload, this.initialize);
    }

    public esdtUnSetRole = async (
        payload: EsdtSetRole
    ): Promise<any> => {
        return await esdtUnSetRole(payload, this.initialize);
    }

    public esdtLocalMint = async (
        payload: EsdtLocalMint
    ): Promise<any> => {
        return await esdtLocalMint(payload, this.initialize);
    }

    public esdtLocalBurn = async (
        payload: EsdtLocalBurn
    ): Promise<any> => {
        return await esdtLocalBurn(payload, this.initialize);
    }

    public esdtPause = async (
        payload: EsdtPause
    ): Promise<any> => {
        return await esdtPause(payload, this.initialize);
    }

    public esdtUnPause = async (
        payload: EsdtUnPause
    ): Promise<any> => {
        return await esdtUnPause(payload, this.initialize);
    }

    public esdtFreeze = async (
        payload: EsdtFreeze
    ): Promise<any> => {
        return await esdtFreeze(payload, this.initialize);
    }

    public esdtUnFreeze = async (
        payload: EsdtUnFreeze
    ): Promise<any> => {
        return await esdtUnFreeze(payload, this.initialize);
    }

    public esdtWipe = async (
        payload: EsdtWipe
    ): Promise<any> => {
        return await esdtWipe(payload, this.initialize);
    }

    public esdtControlChanges = async (
        payload: EsdtControlChanges
    ): Promise<any> => {
        return await esdtControlChanges(payload, this.initialize);
    }

    public nftCreate = async (
        payload: NftCreate
    ): Promise<any> => {
        return await nftCreate(payload, this.initialize);
    }

    public nftTransfer = async (
        payload: NftTransfer
    ): Promise<any> => {
        return await nftTransfer(payload, this.initialize);
    }

    public nftIssue = async (
        payload: NftIssue
    ): Promise<any> => {
        return await nftIssue(payload, this.initialize);
    }

    public nftSetSpecialRole = async (
        payload: NftSetSpecialRole
    ): Promise<any> => {
        return await nftSetSpecialRole(payload, this.initialize);
    }

    public nftStopNftCreate = async (
        payload: NftStopNftCreate
    ): Promise<any> => {
        return await nftStopNftCreate(payload, this.initialize);
    }

    public nftTransferNftCreateRole = async (
        payload: NftTransferNftCreateRole
    ): Promise<any> => {
        return await nftTransferNftCreateRole(payload, this.initialize);
    }

    public nftUpdateAttributes = async (
        payload: NftUpdateAttributes
    ): Promise<any> => {
        return await nftUpdateAttributes(payload, this.initialize);
    }

    public nftAddUri = async (
        payload: NftAddUri
    ): Promise<any> => {
        return await nftAddUri(payload, this.initialize);
    }

    public nftFreezeSingleNft = async (
        payload: NftFreezeSingleNft
    ): Promise<any> => {
        return await nftFreezeSingleNft(payload, this.initialize);
    }

    public nftUnFreezeSingleNft = async (
        payload: NftUnFreezeSingleNft
    ): Promise<any> => {
        return await nftUnFreezeSingleNft(payload, this.initialize);
    }

    public nftWipeSingleNft= async (
        payload: NftWipeSingleNft
    ): Promise<any> => {
        return await nftWipeSingleNft(payload, this.initialize);
    } 

    public sftIssue= async (
        payload: SftIssue
    ): Promise<any> => {
        return await sftIssue(payload, this.initialize);
    } 

    public sftEsdtNftCreate= async (
        payload: SftEsdtNftCreate
    ): Promise<any> => {
        return await sftEsdtNftCreate(payload, this.initialize);
    } 

    public sftSetSpecialRole= async (
        payload: SftSetSpecialRole
    ): Promise<any> => {
        return await sftSetSpecialRole(payload, this.initialize);
    } 

    public sftEsdtNftAddQuantity= async (
        payload: SftEsdtNftAddQuantity
    ): Promise<any> => {
        return await sftEsdtNftAddQuantity(payload, this.initialize);
    } 

    public sftEsdtNftBurn= async (
        payload: SftEsdtNftBurn
    ): Promise<any> => {
        return await sftEsdtNftBurn(payload, this.initialize);
    } 
    
    public metaEsdtRegisterMetaEsdt= async (
        payload: MetaEsdtRegisterMetaEsdt
    ): Promise<any> => {
        return await metaEsdtRegisterMetaEsdt(payload, this.initialize);
    } 

    public metaEsdtChangeNftToMetaEsdt= async (
        payload: MetaEsdtChangeNftToMetaEsdt
    ): Promise<any> => {
        return await metaEsdtChangeNftToMetaEsdt(payload, this.initialize);
    } 

    public multiversXstatus= async (
        payload: MultiversGetTxStatus
    ): Promise<any> => {
        return await multiversxGetTxStatus(payload, this.initialize);
    }

    public getCollectionInfoMultiversX = async (
        payload: GetCollectionInfo
    ): Promise<any> => {
        return await getCollectionInfo(payload, this.initialize);
    }

    public getTokenInfoMultiversX = async (
        payload: GetTokenInfo
    ): Promise<any> => {
        return await getTokenInfo(payload, this.initialize);
    }
    
}